import { Button } from '@/components/ui/button'

export default function ValidatorPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Validator Dashboard</h1>
      <p className="text-gray-500">Validator configuration and assignments - coming soon</p>
      <Button variant="outline" className="mt-4">
        Become Validator
      </Button>
    </div>
  )
}
